// Conversion factors: 1 unit = TO_SI[unit] SI base units
// Tables are organized by quantity family; converter handlers look up by family.

export const PRESSURE_TO_PA: Record<string, number> = {
  psi: 6894.76, psia: 6894.76, psig: 6894.76, psf: 47.8803,
  bar: 100000, kpa: 1000, mpa: 1e6, pa: 1, hpa: 100, mbar: 100,
  inh2o: 248.8, fth2o: 2989.07, inhg: 3377, mmhg: 133.322,
  torr: 133.322, atm: 101325, kgcm2: 98066.5
};

export const VOLFLOW_TO_M3S: Record<string, number> = {
  scfm: 0.000471947, acfm: 0.000471947, icfm: 0.000471947, ncfm: 0.000471947, cfm: 0.000471947,
  scfh: 0.00000786579, sm3h: 1/3600, nm3h: 1/3600,
  m3h: 1/3600, m3min: 1/60, m3s: 1,
  lpm: 1e-3/60, ls: 1e-3, lh: 1e-3/3600,
  gpm: 0.0000630902, usgpm: 0.0000630902, impgpm: 0.0000757682, gph: 0.00000105150
};

export const POWER_TO_W: Record<string, number> = {
  w: 1, kw: 1000, mw: 1e6,
  hp: 745.6999, bhp: 745.7, ps: 735.4988,
  btuhr: 0.293071, btumin: 17.5843,
  mbh: 293.071,
  rt: 3516.85, ton: 3516.85
};

export const TORQUE_TO_NM: Record<string, number> = {
  nm: 1, nmm: 0.001,
  inlb: 0.112985, ftlb: 1.355818, lbfft: 1.355818, kgcm: 0.0980665
};

export const ENERGY_TO_J: Record<string, number> = {
  j: 1, kj: 1000, mj: 1e6, wh: 3600, kwh: 3.6e6,
  btu: 1055.06, mmbtu: 1.05506e9, therm: 1.05506e8,
  cal: 4.184, kcal: 4184,
  kcalmol: 4184, kjmol: 1000
};

export const DENSITY_TO_KGM3: Record<string, number> = {
  kgm3: 1, gcm3: 1000, kgl: 1000,
  lbft3: 16.01846337, lbgal: 119.826427,
  mgm3: 1e-3, ppm: 1
};

export const LENGTH_TO_M: Record<string, number> = {
  m: 1, cm: 0.01, mm: 0.001,
  ft: 0.3048, in: 0.0254, yd: 0.9144
};

export const VISCOSITY_DYNAMIC_TO_PAS: Record<string, number> = {
  pa_s: 1, cp: 0.001, poise: 0.1
};

export const VISCOSITY_KINEMATIC_TO_M2S: Record<string, number> = {
  m2s: 1, cst: 1e-6, st: 1e-4
};

export const VOLUME_TO_M3: Record<string, number> = {
  m3: 1, l: 0.001, dm3: 0.001,
  gal: 0.00378541, usgal: 0.00378541, impgal: 0.00454609,
  ft3: 0.0283168, in3: 0.0000163871, bbl: 0.158987
};

export const VELOCITY_TO_MS: Record<string, number> = {
  ms: 1, kmh: 0.277778, mph: 0.44704, fts: 0.3048, fpm: 0.00508, knot: 0.514444
};

export const AREA_TO_M2: Record<string, number> = {
  m2: 1, cm2: 1e-4, mm2: 1e-6, ft2: 0.092903, in2: 0.00064516
};
